/**
 * The item opener for every page (MainLayout puts it round the page): Open item, New item and New
 * From Existing beside an item picker anywhere on the site open over the screen, in the Quick item
 * dialog or the whole item page, never in a new browser tab (Jeff 2026-11-03: "stay in same tab. no
 * switching tabs."). A screen with a host of its own (the Menu Cycle editor, Menu Import, the Basic
 * menu) nests it, and its own is the one its buttons use.
 *
 * The dialog's code loads on first use here (no preload), so a page that never opens an item pays
 * nothing for it.
 */
import type { ReactNode } from 'react';
import { useGlobalStore } from '../../stores/globalStore';
import { ItemEditorOpenerContext } from './itemEditorOpener';
import { useQuickItemHost } from './useQuickItemHost';

export default function SiteItemEditorHost({ children }: { children: ReactNode }) {
  const facilityId = useGlobalStore((s) => s.facilityId);
  const host = useQuickItemHost(facilityId, { preload: false });
  return (
    <ItemEditorOpenerContext.Provider value={host.opener}>
      {children}
      {host.element}
    </ItemEditorOpenerContext.Provider>
  );
}
